export const getSystemParameterValue = (list = [], code) => {
  const position = list.findIndex((element) => element.code === code);
  if (position === -1) {
    return '';
  }
  return list[position].value;
};

export const buildParameters = (filters) => {
  const {
    filterCodeText,
    filterDescriptionText,
    filterLocationText,
    filterClassificationText,
    filterMotorText,
    filterBrandText,
    filterOriginText,
  } = filters;

  const parameters = {
    'code': filterCodeText,
    'name': filterDescriptionText,
    'location': filterLocationText,
    'classification': filterClassificationText,
    'motor': filterMotorText,
    'brand': filterBrandText,
    'origin': filterOriginText,
  };
  Object.keys(parameters).forEach((key) => {
    if (!parameters[key]) {
      delete parameters[key];
    }
  });
  return parameters;
};
